import React from "react";
import "./styles/ContactFooter.css";
import { useWindowWidth } from "../context/WindowWidthContext";

const ButtonGroup = ({ support }) => {
  const { isMobile } = useWindowWidth();
  return (
    <div id="BUTTON_GROUP2" className="wrap-ladi-element fixed-bottom-menu">
      <div
        className={isMobile ? "container contact-footer-mobile" : "container"}
      >
        <div className="ladi-button-group">
          {/* <a
            href={support.homeFooter}
            id="BUTTON12"
            className="ladi-element"
          >
            <div className="ladi-button ladi-button-home">
              <div class="ladi-button-background"></div>

              <div
                id="BUTTON_TEXT12"
                className="ladi-element ladi-button-headline"
              >
                <div
                  id="BUTTON_SHAPE12"
                  className="ladi-element-custom ladi-button-shape"
                >
                  <div className="ladi-shape">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="100%"
                      height="100%"
                      preserveAspectRatio="none"
                      viewBox="0 0 24 24"
                      fill="rgba(217, 217, 217, 1)"
                    >
                      <path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z"></path>
                    </svg>
                  </div>
                </div>
                <p className="ladi-headline">&nbsp; &nbsp; Trang chủ</p>
              </div>
            </div>
          </a> */}

          <a
            href={support.healthFooter}
            rel="noopener noreferrer"
            id="BUTTON12"
            className="ladi-element"
          >
            <div className="ladi-button">
              <div className="ladi-button-background"></div>
              <div
                id="BUTTON_TEXT13"
                className="ladi-element ladi-button-headline"
              >
                <p className="ladi-headline">
                  <div className="ladi-shape">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="100%"
                      height="100%"
                      preserveAspectRatio="none"
                      viewBox="0 0 24 24"
                      fill="rgba(217, 217, 217, 1)"
                    >
                      <path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z"></path>
                    </svg>
                  </div>
                  &nbsp; Trang chủ
                </p>
              </div>
            </div>
          </a>

          <a
            href={support.healthFooter}
            rel="noopener noreferrer"
            id="BUTTON13"
            className="ladi-element"
          >
            <div className="ladi-button">
              <div className="ladi-button-background"></div>
              <div
                id="BUTTON_TEXT13"
                className="ladi-element ladi-button-headline"
              >
                <p className="ladi-headline">⭐&nbsp; Piano cho bé</p>
              </div>
            </div>
          </a>

          <a
            href={support.interactFooter}
            rel="noopener noreferrer"
            id="BUTTON14"
            className="ladi-element"
          >
            <div className="ladi-button">
              <div className="ladi-button-background"></div>
              <div
                id="BUTTON_TEXT14"
                className="ladi-element ladi-button-headline"
              >
                <p className="ladi-headline">Piano cho bố mẹ</p>
              </div>
            </div>
          </a>

          <a
            href={support.supportFooter}
            rel="noopener noreferrer"
            id="BUTTON15"
            className="ladi-element"
          >
            <div className="ladi-button">
              <div className="ladi-button-background"></div>
              <div
                id="BUTTON_TEXT15"
                className="ladi-element ladi-button-headline"
              >
                <p className="ladi-headline">Hỗ Trợ</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ButtonGroup;
